import { ComponentProps } from "react";
import { twMerge } from "tailwind-merge";

import { LangSwitch } from "@/components/lang-switch";
import { useLang } from "@/hooks/use-lang";

export const LanguageSwitch = (props: ComponentProps<"div">) => {
  const { t } = useLang();
  return (
    <div
      {...props}
      className={twMerge(
        "flex w-full items-center justify-between px-4 py-2 text-sm text-gray-700 hover:bg-gray-100",
        props.className
      )}
    >
      {t.layout.navbar.language}
      <LangSwitch colorScheme="blue" />
    </div>
  );
};
